<script>

import { municipalityOptions } from '@/config'
import SingleSelectFilter from './SingleSelectFilter.vue'

export default {
  name: 'MunicipalityFilter',
  mixins: [SingleSelectFilter],
  computed: {
    options: () => municipalityOptions,
  },
}
</script>
